<fin-loyalty-view [pageTitle]="pageTitle$ | async">
  <ng-container>
    <div class="nordic-blue-900-text font-body-1 fill align-center" *ngIf="status === Status.LOADING">
      <fcom-loader [loaderType]="LoaderTheme.INLINE"> </fcom-loader>
    </div>
    <ng-container *ngIf="profile$ | async as profile">
      <div class="trigger flex flex--center pr-small-b">
        <div class="flex-1 medium-type">
          <span class="nordic-blue-900-text font-heading-4">{{
            'plus.profile.personalInformation' | finLocalization
          }}</span>
        </div>
      </div>
      <div class="content pr-medium-b">
        <fin-loyalty-personal-information-form></fin-loyalty-personal-information-form>
      </div>
      <fin-expand #expandTwoFactorAuth [key]="'update-profile'" [id]="'two-factor-auth'" class="block">
        <div data-testid="update-profile-toggle-advanced-security" #expandTwoFactorAuthTrigger class="trigger">
          <ng-container
            [ngTemplateOutlet]="expandHeader"
            [ngTemplateOutletContext]="{
              label: 'plus.profile.advancedSecurity',
              isOpen: expandTwoFactorAuth.isOpen$ | async,
            }"
          ></ng-container>
        </div>
        <div class="content ps-xxsmall-t pr-medium-b">
          <fin-loyalty-two-factor-auth-toggle
            [enabledBackButtonUrl]="(routerParams$ | async)?.[PlusProfileQueryParams.TwoFactorAuthEnabledBackButtonUrl]"
          ></fin-loyalty-two-factor-auth-toggle>
        </div>
      </fin-expand>
      <fin-expand
        *ngIf="profile.isJuniorMember"
        class="block"
        [key]="'update-profile'"
        [id]="'guardian-information'"
        #expandGuardianInformation
      >
        <div class="trigger">
          <ng-container
            [ngTemplateOutlet]="expandHeader"
            [ngTemplateOutletContext]="{
              label: 'plus.profile.guardianInformation',
              isOpen: expandGuardianInformation.isOpen$ | async,
            }"
          ></ng-container>
        </div>
        <div class="content ps-xxsmall-t pr-medium-b">
          <fin-guardian-information-form></fin-guardian-information-form>
        </div>
      </fin-expand>
      <fin-expand class="block" [key]="'update-profile'" [id]="'mailing-address'" #expandMailingAddress>
        <div class="trigger toggle-mailing-address" #expandMailingAddressTrigger>
          <ng-container
            [ngTemplateOutlet]="expandHeader"
            [ngTemplateOutletContext]="{
              label: 'plus.profile.mailingAddress',
              isOpen: expandMailingAddress.isOpen$ | async,
            }"
          ></ng-container>
        </div>
        <div class="content ps-xxsmall-t pr-medium-b">
          <fin-loyalty-mailing-address-form></fin-loyalty-mailing-address-form>
        </div>
      </fin-expand>
      <fin-expand class="block" [key]="'update-profile'" [id]="'marketing-preferences'" #expandMarketingPreferences>
        <div class="trigger" #expandMarketingPreferencesTrigger>
          <ng-container
            [ngTemplateOutlet]="expandHeader"
            [ngTemplateOutletContext]="{
              label: 'plus.profile.marketingPreferences',
              isOpen: expandMarketingPreferences.isOpen$ | async,
            }"
          ></ng-container>
        </div>
        <div class="content ps-xxsmall-t pr-medium-b">
          <fin-direct-marketing-preferences-form></fin-direct-marketing-preferences-form>
        </div>
      </fin-expand>
      <fin-expand [key]="'update-profile'" [id]="'travel-profile'" #expandTravelProfile>
        <div class="trigger toggle-travel-profile" #expandTravelProfileTrigger>
          <ng-container
            [ngTemplateOutlet]="expandHeader"
            [ngTemplateOutletContext]="{
              label: 'plus.profile.travelProfile.heading',
              isOpen: expandTravelProfile.isOpen$ | async,
            }"
          ></ng-container>
        </div>
        <div class="content ps-xxsmall-t pr-medium-b">
          <fin-loyalty-travel-profile-form></fin-loyalty-travel-profile-form>
        </div>
      </fin-expand>
      <fin-expand class="block" [key]="'update-profile'" [id]="'payment-cards'" #expandPaymentCards>
        <div data-testid="loyalty-ptofile-toggle-payment-cards" class="trigger">
          <ng-container
            [ngTemplateOutlet]="expandHeader"
            [ngTemplateOutletContext]="{
              label: 'plus.profile.paymentCards.heading',
              isOpen: expandPaymentCards.isOpen$ | async,
            }"
          ></ng-container>
        </div>
        <div class="content ps-xxsmall-t pr-medium-b">
          <fin-loyalty-payment-cards></fin-loyalty-payment-cards>
        </div>
      </fin-expand>
      <fin-expand
        class="block border-bottom mr-large-b"
        [key]="'update-profile'"
        [id]="'passport-information'"
        #expandPassportInformation
      >
        <div class="trigger toggle-passport-information">
          <ng-container
            [ngTemplateOutlet]="expandHeader"
            [ngTemplateOutletContext]="{
              label: 'plus.profile.passportInformation',
              isOpen: expandPassportInformation.isOpen$ | async,
            }"
          ></ng-container>
        </div>
        <div class="content ps-xxsmall-t pr-medium-b">
          <fin-loyalty-passport-information-form></fin-loyalty-passport-information-form>
        </div>
      </fin-expand>
    </ng-container>
  </ng-container>
</fin-loyalty-view>

<ng-template #expandHeader let-isOpen="isOpen" let-label="label">
  <div class="flex flex--center border-top pr-small-y" tabindex="-1">
    <div class="flex-1 medium-type">
      <span class="nordic-blue-900-text font-heading-4">{{ label | finLocalization }}</span>
    </div>
    <fcom-icon
      class="flex-1 flex--nogrow rotate icon-medium"
      [class.rotate-active]="isOpen"
      [name]="SvgLibraryIcon.CHEVRON_DOWN"
    ></fcom-icon>
  </div>
</ng-template>
